module.exports = __webpack_public_path__ + "img/loading.75a84afe.svg";